const config = {
  tabs: [
    {
      header: 'Cost Of Living',
      trackingFieldName: 'nav-bar-col',
    },
    {
      header: 'Demographics',
      trackingFieldName: 'nav-bar-demographics',
    },
    {
      header: 'Quality of Life',
      trackingFieldName: 'nav-bar-qol',
    },
    {
      header: 'School',
      trackingFieldName: 'nav-bar-school',
    },
    {
      header: 'How does it compare?',
      trackingFieldName: 'nav-bar-compare',
    },
  ],
};
export default config;
